import { Button, Modal } from '@dev-spendesk/grapes';
import { type Dispatch } from 'react';

import { useTranslation } from 'src/core/common/hooks/useTranslation';

import { type ModalState } from './ModalState';
import { type AnalyticalFieldMappingUpdate } from '../../../../../hooks/useUpdateAnalyticalFieldMappingMutation';

interface Props {
  modalState: ModalState;
  setModalState: Dispatch<ModalState>;
  onUpdate: (
    editedAnalyticalField: AnalyticalFieldMappingUpdate & {
      externalName: string;
    },
  ) => void;
}

export const StaticMapAndPullAndMapConfirmChangesModal = ({
  modalState,
  setModalState,
  onUpdate,
}: Props) => {
  const { t } = useTranslation('global');

  const subtitle =
    modalState.modalKind === 'confirmChanges'
      ? t(
          'bookkeep.integrations.settings.analyticalFieldsMappingsTable.confirmChanges.subtitle',
          {
            ...modalState.existingAnalyticalFiledMap,
          },
        )
      : '';

  return (
    <Modal
      actions={[
        <Button
          key="no"
          onClick={() => setModalState({ modalKind: 'closed' })}
          text={t('misc.cancel')}
          variant="secondaryNeutral"
        />,
        <Button
          key="yes"
          text={t(
            'bookkeep.integrations.settings.analyticalFieldsMappingsTable.confirmChanges.confirmChanges',
          )}
          variant="primaryBrand"
          onClick={() => {
            if (modalState.modalKind === 'confirmChanges') {
              onUpdate(modalState);
            }

            setModalState({ modalKind: 'closed' });
          }}
        />,
      ]}
      onClose={() => {
        setModalState({ modalKind: 'closed' });
      }}
      iconName="triangle-warning"
      title={t(
        'bookkeep.integrations.settings.analyticalFieldsMappingsTable.confirmChanges.title',
      )}
      subtitle={subtitle}
      iconVariant="warning"
      isOpen={modalState.modalKind === 'confirmChanges'}
    />
  );
};
